// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2ViGz","title":"BackImages_title__hrpnn","images":"BackImages_images__3dyRs"};